
import Vue from 'vue'
import Router from 'vue-router'
import 'vue-country-region-select'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'


////////////DV7 Admin Views

//Auth
const Auth = () => import('@/views/auth/Auth')

//Teams
const Teams = () => import('@/views/teams/Teams')
const Team = () => import('@/views/teams/Team')
const AddTeam = () => import('@/views/teams/AddTeam')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')
const AddUser = () => import('@/views/users/AddUser')

// News
const News = () => import('@/views/news/News')
const SingleNews = () => import('@/views/news/SingleNews')
const AddNews = () => import('@/views/news/AddNews')

// Events
const Events = () => import('@/views/events/Events')
const SingleEvent = () => import('@/views/events/SingleEvent')
const AddEvent = () => import('@/views/events/AddEvent')

// Matches
const Matches = () => import('@/views/matches/Matches')
const AddMatch = () => import('@/views/matches/AddMatch')

// Trainings
const Trainings = () => import('@/views/trainings/Trainings')
const AddTraining = () => import('@/views/trainings/AddTraining')

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')


Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.use(Router)


export default new Router({
  data: () => ({
    country: '',
    region: ''
  }),
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/auth', 
      component: Auth
    },
    {
      path: '',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'teams',
          meta: { label: 'Teams'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Teams,
            },
            {
              path: 'addteam',
              meta: { label: 'Add Team'},
              component: AddTeam,
            },
            {
              path: ':id',
              meta: { label: 'Team Details'},
              component: AddTeam,
            },
            
          ]
        },
        {
          path: 'matches',
          meta: { label: 'Matches'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Matches,
            },
            {
              path: 'addmatch',
              meta: { label: 'Add Match'},
              component: AddMatch,
            },
            {
              path: ':info',
              meta: { label: 'Match Details'},
              component: AddMatch,
            },
            
          ]
        },
        {
          path: 'trainings',
          meta: { label: 'Training'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Trainings,
            },
            {
              path: 'addtraining',
              meta: { label: 'Add Training'},
              component: AddTraining,
            },
            {
              path: ':info',
              meta: { label: 'Training Details'},
              component: AddTraining,
            },
            
          ]
        },
        {
          path: 'events',
          meta: { label: 'Events'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Events,
            },
            {
              path: 'addevent',
              meta: { label: 'Add Event'},
              component: AddEvent,
            },
            {
              path: ':id',
              meta: { label: 'Event Details'},
              component: AddEvent,
            },
            
          ]
        },
        {
          path: 'news',
          meta: { label: 'News'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: News,
            },
            {
              path: 'addnews',
              meta: { label: 'Add News'},
              component: AddNews,
            },
            {
              path: ':id/:isPublished',
              meta: { label: 'News Details'},
              component: AddNews,
            },
            
          ]
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: 'adduser',
              meta: { label: 'Add User'},
              component: AddUser
            },
            {
              path: ':info',
              meta: { label: 'User Details'},
              component: AddUser
            },
          ]
        }
        
      ]
    }

  ]
})
